import { importProvidersFrom } from '@angular/core';
import { LoggerModule } from 'ngx-logger';
import { loggerConfig } from './logger.config';

export const provideLoggerCore = () => importProvidersFrom(LoggerModule.forRoot(loggerConfig));
